import React, { useState } from 'react'
import { useFormik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import firebase from 'firebase/app'
import { cloudFunctionsInstance } from 'config/axios'
import { toast } from 'utils/notify'
import authSlice, { signOut } from 'store/auth'
import SetNewPasswordCard, { setPasswordSchema } from 'components/SetNewPasswordCard'

const ForcePasswordChange = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { user } = useSelector((state) => state.auth)
  const [performingAction, setPerformingAction] = useState(false)
  const [signingOut, setSigningOut] = useState(false)

  const handleBackToLogin = async () => {
    setSigningOut(true)
    await dispatch(signOut())
    history.replace('/')
  }

  const onSubmit = async (values) => {
    try {
      setPerformingAction(true)
      const idToken = await firebase.auth().currentUser.getIdToken()
      await cloudFunctionsInstance.post(
        '/setNewPassword',
        { newPassword: values.password },
        { headers: { Authorization: `Bearer ${idToken}` } }
      )
      dispatch(authSlice.actions.setUser({ ...user, mustChangePassword: false }))
      toast.success('Password updated.')
    } catch (error) {
      toast.error(error?.response?.data?.msg || 'Could not update your password. Please try again.')
    } finally {
      setPerformingAction(false)
    }
  }

  const formik = useFormik({
    initialValues: {
      password: '',
      confirmPassword: ''
    },
    validationSchema: setPasswordSchema,
    onSubmit: onSubmit
  })

  return (
    <SetNewPasswordCard
      email={user?.email}
      formik={formik}
      submitting={performingAction}
      onBack={handleBackToLogin}
      backLabel={signingOut ? 'Signing out...' : 'Back to Login'}
      backDisabled={signingOut}
    />
  )
}

export default ForcePasswordChange
